var _path, _path2, _path3, _path4, _rect, _rect2, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 504.799,
    viewBox: "0 0 838.547 504.799",
    width: 838.547,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m314.621 389.062s109.089 226.226 465.674 109.395 170.523-336.348 10.1-257.05-305.023-20.107-305.023-20.107-97.584-57.189-165.079 24.017c0 .001-49.493 52.928-5.672 143.745z",
    fill: "#f5f5fe",
    transform: "translate(-217.772 -27.326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m403.945 214.764s-9.548 69.195 120.489 68.646 185.966-97.486 142.711-121.558c-37.889-21.083-85.647 14.841-138.556-1.344-67.948-20.788-126.276 12.327-124.644 54.256z",
    fill: "#f5f5fe",
    transform: "translate(-97.995 -80.494)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m443.349 157.685h-127.616a4.775 4.775 0 0 1 -4.775-4.775 4.774 4.774 0 0 1 4.775-4.773h127.616a4.774 4.774 0 0 1 4.775 4.773 4.775 4.775 0 0 1 -4.775 4.775z",
    fill: "#6f7de0",
    transform: "translate(-201.644 -87.18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m674.224 330.2h-38.835a4.774 4.774 0 0 1 -4.775-4.773 4.775 4.775 0 0 1 4.775-4.775h38.835a4.775 4.775 0 0 1 4.776 4.775 4.774 4.774 0 0 1 -4.776 4.773z",
    fill: "#fe4777",
    transform: "translate(155.27 105.443)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fe4777",
    height: 14.307,
    rx: 1.701,
    width: 14.771,
    x: 432.982,
    y: 6.332
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fe4777",
    height: 14.307,
    rx: 1.701,
    width: 14.771,
    x: 74.007,
    y: 453.298
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m665.671 272.531a10.064 10.064 0 1 1 -10.062-10.2 10.135 10.135 0 0 1 10.062 10.2z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.87,
    transform: "translate(171.941 40.319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.529 246.215a10.389 10.389 0 1 1 -10.388-10.534 10.461 10.461 0 0 1 10.388 10.534z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.87,
    transform: "translate(-258.818 10.567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m732.557 73.25h53.035",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.356 397.404h117.004",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.87
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(649.285 160.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#6f7de0",
    height: 39.842,
    rx: 1.792,
    width: 133.069
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2 13.667h89.083",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.702
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2 24.352h31.247",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.702
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.952 211.918v14.948l18.8-14.948z",
    fill: "#6f7de0",
    transform: "translate(-558.398 -176.416)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.947 0h92.913a4.947 4.947 0 0 1 4.947 4.947v87.392a4.947 4.947 0 0 1 -4.947 4.947h-91.335a6.525 6.525 0 0 1 -6.525-6.525v-85.814a4.947 4.947 0 0 1 4.947-4.947z",
    fill: "#f94f4f",
    transform: "translate(59.451 128.009)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m348.088 225.411-6.1-6.1a5.347 5.347 0 0 0 -3.922-1.854 5.652 5.652 0 0 0 -3.924 1.744l-3.486 3.488-.654-.328a10.246 10.246 0 0 1 -1.09-.544 37.636 37.636 0 0 1 -9.044-8.282 19.714 19.714 0 0 1 -2.832-4.468c.87-.762 1.634-1.634 2.4-2.4.328-.328.654-.654.98-.982a5.309 5.309 0 0 0 0-8.062l-3.05-3.052a9.72 9.72 0 0 1 -.98-1.09l-2.072-2.07a5.644 5.644 0 0 0 -3.922-1.742 5.4 5.4 0 0 0 -3.922 1.742l-3.814 3.814a8.769 8.769 0 0 0 -2.506 5.34 19.853 19.853 0 0 0 1.416 8.28 44.6 44.6 0 0 0 8.5 14.276 52.966 52.966 0 0 0 17.434 13.62 28.968 28.968 0 0 0 9.806 2.942h.764a8.652 8.652 0 0 0 6.538-2.834l.108-.108a16.486 16.486 0 0 1 1.962-1.962l1.416-1.416a5.466 5.466 0 0 0 -.006-7.952zm-2.506 5.666-1.308 1.308c-.762.652-1.416 1.416-2.18 2.178a5.176 5.176 0 0 1 -3.922 1.636h-.544a22.963 22.963 0 0 1 -8.5-2.616 49.63 49.63 0 0 1 -16.236-12.748 47.3 47.3 0 0 1 -7.954-13.186 13.5 13.5 0 0 1 -1.308-6.756 4.609 4.609 0 0 1 1.526-3.16l3.7-3.7a2.284 2.284 0 0 1 1.526-.764 2.083 2.083 0 0 1 1.526.764l1.962 1.962a10.132 10.132 0 0 0 1.088 1.088l3.052 3.052a2.559 2.559 0 0 1 .762 1.526 2.286 2.286 0 0 1 -.762 1.524c-.328.328-.654.654-.98.982-.982.98-1.854 1.852-2.726 2.724l-.104.109a2.386 2.386 0 0 0 -.654 2.724v.11a25.186 25.186 0 0 0 3.6 5.884 40.418 40.418 0 0 0 9.916 9.044 9.08 9.08 0 0 0 1.416.762 10.017 10.017 0 0 1 1.09.546l.108.108a2.5 2.5 0 0 0 3.052-.544l3.814-3.814a1.8 1.8 0 0 1 2.942 0l6.1 6.1a2.065 2.065 0 0 1 -.002 3.157z",
    fill: "#fff",
    transform: "translate(-213.757 -40.805)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m4.54 0h85.277a4.54 4.54 0 0 1 4.54 4.54v80.21a4.54 4.54 0 0 1 -4.54 4.54h-83.828a5.989 5.989 0 0 1 -5.989-5.99v-78.76a4.54 4.54 0 0 1 4.54-4.54z",
    fill: "#fe4777",
    transform: "translate(542.523)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m555.233 143.028a11.457 11.457 0 1 0 -11.457 11.457 11.457 11.457 0 0 0 11.457-11.457zm-20.05 0a8.593 8.593 0 1 1 8.593 8.591 8.593 8.593 0 0 1 -8.593-8.591z",
    fill: "#fff",
    transform: "translate(45.517 -105.68)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m546.4 180.59a1.428 1.428 0 0 0 2.311 0c.116-.159.662-.906 1.49-2.083l8.454-13.076c3.928-6.7 7.52-14.069 7.52-18.626a18.618 18.618 0 1 0 -37.237 0c0 4.426 3.389 11.506 7.181 18.046l8.8 13.662c.82 1.175 1.364 1.918 1.481 2.077zm1.156-49.538a15.752 15.752 0 0 1 15.753 15.754c0 6.851-10.471 23.039-15.753 30.487-5.281-7.448-15.753-23.636-15.753-30.487a15.754 15.754 0 0 1 15.75-15.754z",
    fill: "#fff",
    transform: "translate(41.74 -109.457)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m573.828 495.168c-.768-2.3-39.7-182.672-51.5-237.319a23.612 23.612 0 0 0 -19.362-18.372c-28.381-4.54-90.189-11.021-150.849 5.09-12.431 3.3-26.245 20.965-20.476 42.575l51.712 208.026z",
    fill: "#4c53bb",
    transform: "translate(-180.063 8.991)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m576.48 495.373c-.768-2.3-40.043-184.083-51.843-238.731a23.612 23.612 0 0 0 -19.362-18.372c-28.381-4.54-90.187-11.019-150.849 5.09a23.706 23.706 0 0 0 -16.844 28.533l54.428 223.48z",
    fill: "#6f7de0",
    transform: "translate(-172.676 7.645)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m489.686 207.13s-39.747 3.34-52.072 33.619 0 37.8-18.486 48.983-59.1 41.918-19.386 102.611l207.264-20.014c-.789-.866 38.716-72.594-30.318-120.889z",
    transform: "translate(-121.305 -21.312)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc4a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m537.76 251.513-12.847 39.715 35.552 8.748 11.477-38.487z",
    transform: "translate(37.247 28.244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.054 283.782s25.348 16.867 32.466 11.954c12.441-8.587 24.673-42.441 24.673-42.441s-48.078-22.245-47.667-21.483-9.472 51.97-9.472 51.97z",
    transform: "translate(42.988 6.226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.476 282.137c-5.222-3.867-7.461-14.01-10.25-43.114a4.993 4.993 0 0 1 4.195-5.708c1.863-.218 4.752.22 5.935 2.953l10.854 22.1z",
    transform: "translate(37.566 7.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.552 265.822 11.6-41.736a5.345 5.345 0 0 1 6.472-3.776 4.6 4.6 0 0 1 3.4 5.368l-6.011 31.268z",
    transform: "translate(44.661 -6.787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.089 252.092 13.768-29.4a5.323 5.323 0 0 1 6.807-2.756 4.586 4.586 0 0 1 2.625 5.647l-11.129 34.317z",
    transform: "translate(54.193 -7.446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.652 256.223 16.8-28.652a5.83 5.83 0 0 1 7.632-2.3 5.078 5.078 0 0 1 2.125 6.881l-13.709 27.202z",
    transform: "translate(60.404 -1.752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563 254.374 12.807-17.368a4.125 4.125 0 0 0 -1.607-5.641 4.708 4.708 0 0 0 -5.856 1.251l-16.623 19.839z",
    transform: "translate(67.181 5.147)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m532.754 240.3s17.37-.55 17.466 22.552",
    fill: "none",
    stroke: "#e5967a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.064,
    transform: "translate(46.003 15.722)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m469.411 265.2c25.267 15.059 80.025 72.42 80.025 72.42l35.154-77.157 59.143 10.888s-39.15 101.614-58.654 133.688c-10.157 16.706-29.507 26.98-52.006 15.184l-63.04-38.441z",
    fill: "#fe4777",
    transform: "translate(-24.723 38.237)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m499.933 255.423s-79.6 5.943-93.717 58.679-11.884 156.725-11.884 156.725h190.894l-5.943-159.7s-4.206-52.732-79.35-55.704z",
    fill: "#fe4777",
    transform: "translate(-108.697 32.61)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m474.078 437.559-5.077-71.101",
    fill: "none",
    stroke: "#e0225d",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m495.6 434.224 76.99-142.112a6.941 6.941 0 0 1 6.1-3.636h181.943a5.172 5.172 0 0 1 4.616 7.505l-69.884 138.243z",
    fill: "#f2f2f2",
    transform: "translate(4.516 69.516)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m380.426 486.405h143.993v17.335h-143.993z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m588.116 332.388a15.251 15.251 0 1 1 -15.25-15.25 15.251 15.251 0 0 1 15.25 15.25z",
    fill: "#989898",
    transform: "translate(73.761 101.519)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m495.6 434.224 76.56-141.318a8.455 8.455 0 0 1 7.438-4.43h95.533",
    fill: "none",
    stroke: "#0c0b0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277,
    transform: "translate(4.516 69.516)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m456.542 232.472c-.493 14.1 10.689 25.936 28.571 26.561 12.646.442 16.738-10.858 17.231-24.958s-9.359-25.892-22.006-26.334-23.3 10.63-23.796 24.731z",
    fill: "#4040eb",
    transform: "translate(-39.11 -20.645)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m459.644 232.579c-.493 14.1 9.359 25.89 22.008 26.332s23.3-10.629 23.794-24.73-9.359-25.89-22.008-26.332-23.3 10.629-23.794 24.73z",
    fill: "#2a3596",
    transform: "translate(-35.648 -20.523)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m480.533 194.04c2.277-3.988-.65-11.451-.65-11.451-22.476 0-41.87 7.2-53.043 27.731-16.433 30.205-4.5 76.911 34.174 91.122 37.11 13.637 17.345-103.595 17.345-103.595z",
    transform: "translate(-80.273 -48.713)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m483.924 253.692-2.485 36.394c-.845 13.722-9.755 20.537-23.259 19.6-11.529-.8-21.944-7.5-22.577-19.034l3.268-58.62z",
    fill: "#ffc4a7",
    transform: "translate(-62.472 6.489)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m480.875 272.132s-26.707-4.394-43.758-37.3l45.476 11.421z",
    fill: "#e5967a",
    transform: "translate(-60.782 9.617)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m478.511 310.557c23.073.874 41.927-16.535 42.617-35.38l1.361-44.477a43.822 43.822 0 0 0 -40.763-45.311c-17.741-1.234-49.944 25.111-51.007 40.373l-.7 35.783c-.549 27.675 25.894 48.155 48.492 49.012z",
    fill: "#ffc4a7",
    transform: "translate(-68.719 -45.635)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m448.065 182.641c.114-.015.212-.036.326-.051z",
    fill: "#f7de9e",
    transform: "translate(-48.558 -48.712)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m419.85 227.759a17.971 17.971 0 1 0 19.174-16.672 17.965 17.965 0 0 0 -19.174 16.672z",
    fill: "#ffc4a7",
    transform: "translate(-80.11 -16.942)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m437.237 228.523s.9-12.989-11.666-11.81",
    fill: "none",
    stroke: "#20181f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277,
    transform: "translate(-73.675 -10.696)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m463.653 224.53 1.423 11.742-6.083.224",
    fill: "none",
    stroke: "#0c0b0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277,
    transform: "translate(-36.356 -1.884)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m456.1 213.376s12.115-1.64 11.927 2.709c0 0-.22 2.948-10.778 4.2s-13.243.737-14.005-1.973 7.199-4.553 12.856-4.936z",
    transform: "translate(-54 -14.677)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m473.061 213.485s-9.6-1.439-10.136 2.608c0 0-.288 2.743 8.108 3.831s11.059.256 11.713-1.935c.743-2.489-5.141-4.189-9.685-4.504z",
    transform: "translate(-31.967 -14.494)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m448.256 223.6a3.9 3.9 0 1 0 4.021-3.763 3.894 3.894 0 0 0 -4.021 3.763z",
    transform: "translate(-48.346 -7.122)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m465.227 223.6a3.894 3.894 0 1 0 4.019-3.763 3.892 3.892 0 0 0 -4.019 3.763z",
    transform: "translate(-29.397 -7.122)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m450.637 233.376h24.933s-1.156 8.6-14.223 7.96a11.365 11.365 0 0 1 -10.71-7.96z",
    fill: "#f7f7f7",
    transform: "translate(-45.686 7.993)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m429.544 243.861s36.256 12.824 61.756-35.311c0 0 27.74 5.922 33.1 28.58 0 0 14.458-55.373-55.807-55.439l-40.293 24.383z",
    transform: "translate(-70.63 -49.716)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m439.15 273.933 33.905 21.538s3.681-23.629 4.424-35.975z",
    fill: "#ffc4a7",
    transform: "translate(-58.512 37.158)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m500.949 186.419.083 2.362s-29.041-2.148-45.161 12.833c-17.967 16.7-22.9 42.7-22.9 42.7l-6.257-.591 7.865-41.22 14.672-10.644 21.813-8.221 14.573-1.915z",
    fill: "#2a3596",
    transform: "translate(-72.394 -49.681)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m460.668 232.909c.493 14.1-10.689 25.936-28.571 26.563-12.646.442-16.738-10.86-17.231-24.961s9.359-25.89 22.006-26.332 23.3 10.629 23.796 24.73z",
    fill: "#2a3596",
    transform: "translate(-85.647 -20.155)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.915,
    cy: 25.547,
    fill: "#4c53bb",
    rx: 22.915,
    ry: 25.547,
    transform: "matrix(.999 -.035 .035 .999 321.758 189.059)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m422.622 243.167a97.65 97.65 0 0 1 6.938-31.35c8.316-20.044 27.691-31.922 49.4-31.954q2.486-.006 5.217.116c6.261.288 12.833 1.651 17.868 5.382a22.23 22.23 0 0 1 3.478 3.133s-27.89-3.85-43.887 8.551c-18.027 13.973-26.015 35.681-27.778 50.768z",
    fill: "#4c53bb",
    transform: "translate(-76.966 -51.757)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m431.643 228.877a25.386 25.386 0 0 0 22.524 8.149",
    fill: "none",
    stroke: "#0c0b0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277,
    transform: "translate(-66.894 2.97)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m446.676 233.782a2.6 2.6 0 1 1 -2.6-2.6 2.6 2.6 0 0 1 2.6 2.6z",
    fill: "#0c0b0c",
    transform: "translate(-55.911 5.547)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m474.9 347.787-36.876-5.076 1.029 30.943 28.532-.013z",
    fill: "#ffc4a7",
    transform: "translate(-59.765 130.072)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m457.324 350.107c-1.132-.472 79.278-34.305 73.3 26.228h-80.71z",
    fill: "#ffc4a7",
    transform: "translate(-46.493 127.335)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m402.655 331.763 118.481 3.566-2.227 51.208-123.184-.758a27.231 27.231 0 0 1 -21.707-36.987 27.232 27.232 0 0 1 28.637-17.029z",
    fill: "#fe4777",
    transform: "translate(-133.379 117.622)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m476.234 390.514 2.188-20.4-68.069-2.24 33.247-67.474",
    fill: "none",
    stroke: "#e0225d",
    strokeMiterlimit: 10,
    transform: "translate(-90.664 82.833)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m321.806 450.711-35.998-.436",
    fill: "none",
    stroke: "#e0225d",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m494.674 305.27s-30.167 75.908-73.44 137.087c-4.851 6.856-18.344 10.265-26.736 9.9-18.941-.817-26.967-21.221-19.811-37.825 0 0 34.815-109.418 74.207-145.031.992-.896 45.78 35.869 45.78 35.869z",
    fill: "#fe4777",
    transform: "translate(-133.379 48.204)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m789.274 504.16h-648.013",
    fill: "none",
    stroke: "#0c0b0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m103.704 504.16h-78.224",
    fill: "none",
    stroke: "#0c0b0c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.277
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.68a7b274058825dd0b4bfdda13ed394a.svg";
export { ForwardRef as ReactComponent };